export default (): NavBarComponent => {

    return {
        isMobileMenuOpen: false,
        isUserMenuOpen: false,
        isSearchOpen: false,
        menuAtTop:false
    };
};

import {AlpineComponent} from "alpinejs"

type NavBarComponent = AlpineComponent<{
    isMobileMenuOpen: boolean
    isUserMenuOpen: boolean
    isSearchOpen: boolean
}>
